import auth from "@profilog/misc/localization/translations/ru/auth.json";
import userSettings from "@profilog/front/localization/translations/ru/userSettings.json";
import userSettingsShared from "@profilog/misc/localization/translations/ru/userSettings.json";
import patients from "@profilog/front/localization/translations/ru/patients.json";
import registration from "@profilog/front/localization/translations/ru/registration.json";
import records from "@profilog/front/localization/translations/ru/records.json";
import aboutService from "@profilog/front/localization/translations/ru/aboutService.json";
import footer from "@profilog/front/localization/translations/ru/footer.json";
import groups from "@profilog/front/localization/translations/ru/groups.json";
import header from "@profilog/front/localization/translations/ru/header.json";
import home from "@profilog/front/localization/translations/ru/home.json";
import loginDisplay from "@profilog/front/localization/translations/ru/loginDisplay.json";
import about from "@profilog/front/localization/translations/ru/about.json";
import aboutUs from "@profilog/front/localization/translations/ru/aboutUs.json";
import useCases from "@profilog/front/localization/translations/ru/useCases.json";
import persons from "@profilog/front/localization/translations/ru/persons.json";
import sharing from "@profilog/front/localization/translations/ru/sharing.json";
import cpz from "@profilog/front/localization/translations/ru/cpz.json";
import obefis from "@profilog/front/localization/translations/ru/obefis.json";
import sps from "@profilog/front/localization/translations/ru/sps.json";
import extConnectors from "@profilog/front/localization/translations/ru/extConnectors.json";
import userInitialization from "@profilog/front/localization/translations/ru/userInitialization.json";
import prescriptions from "@profilog/front/localization/translations/ru/prescriptions.json";
import icudemo from "@profilog/front/localization/translations/ru/icudemo.json";

import apiResult from "@profilog/misc/localization/translations/ru/apiResult.json";
import global from "@profilog/misc/localization/translations/ru/global.json";
import recordsVisualization from "@profilog/misc/localization/translations/ru/recordsVisualization.json";
import caloricsTable from "@profilog/misc/localization/translations/ru/caloricsTable.json";
import apiStatusCheck from "@profilog/misc/localization/translations/ru/apiStatusCheck.json";
import communications from "@profilog/front/localization/translations/ru/communications.json";
import shCommunications from "@profilog/misc/localization/translations/ru/communications.json";
import shNotifications from "@profilog/misc/localization/translations/ru/notifications.json";
import feedback from "@profilog/misc/localization/translations/ru/feedback.json";
import ecg from "@profilog/misc/localization/translations/ru/ecg.json";
import surveys from "@profilog/surveys/localization/translations/ru/surveys.json";
import activitiesVisualization from "@profilog/misc/localization/translations/ru/activitiesVisualization.json";

export default {
    auth,
    userSettings: { ...userSettings, ...userSettingsShared },
    patients,
    registration,
    records,
    recordsVisualization,
    aboutService,
    footer,
    global,
    groups,
    header,
    home,
    loginDisplay,
    about,
    aboutUs,
    apiResult,
    useCases,
    persons,
    sharing,
    cpz,
    obefis,
    sps,
    caloricsTable,
    apiStatusCheck,
    extConnectors,
    userInitialization,
    communications,
    shCommunications,
    shNotifications,
    feedback,
    ecg,
    prescriptions,
    icudemo,
    surveys,
    activitiesVisualization,
};
